import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import NextHead from 'next/head'
import Logo from '@components/icons/Logo'
import styles from './MaintenanceBlock.module.scss'

export const MaintenanceBlock = () => {
    const { t } = useTranslation(['common'])
    const { locale } = useRouter()
    const isArabic = locale === 'ar'

    return (
        <div className={styles.maintenance} dir={isArabic ? 'rtl' : undefined}>
            <NextHead>
                <title>{t('Maintenence - Site undergoing maintenance')}</title>
                {isArabic && (
                    <>
                        <link
                            rel="preconnect"
                            href="https://fonts.googleapis.com"
                        />
                        <link
                            rel="preconnect"
                            href="https://fonts.gstatic.com"
                            crossOrigin=""
                        />
                        <link
                            rel="stylesheet"
                            href="https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;700&display=swap"
                        />
                    </>
                )}
            </NextHead>
            <div className={styles['maintenance__content']}>
                <div className={styles['maintenance__logo']}>
                    <Logo />
                </div>
                <div className={styles['maintenance__heading']}>
                    <h1 className={styles['maintenance__title']}>
                        {t('Planned Maintenance in Progress')}
                    </h1>
                    <div className={styles['maintenance__text']}>
                        <p>
                            {t(
                                "We're currently upgrading our systems to deliver a smoother shopping experience for you. We'll be back in a few hours."
                            )}
                        </p>
                        <p>{t('Sorry for the temporary interruption.')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
